define('CustomMerchZone.Pricing.View',
  [
    'SCView',
    'underscore',
    'custom_merch_zone_pricing_view.tpl'
  ],
  function (
    SCViewComponent,
    _,
    Template
  ) {
    'use strict';

    var SCView = SCViewComponent.SCView;

    function CustomMerchZonePricingView(opts) {
      SCView.call(this);

      this.template = Template;

      this.initialize = function initialize(options) {
        this.model = options.model;
        this.isLoggedIn = options.isLoggedIn;
        this.merchZoneConfig = options.merchZoneConfig;
        this.pricingConditionsInfo = options.pricingConditionsInformation;
        this.price = options.price;
        this.priceNoFormatted = options.priceNoFormatted;
        this.customRolesConfig = options.customRolesConfig;
        this.customerRole = options.role;
        this.itemInStock = options.itemIsInStock;
        if(this.pricingConditionsInfo && this.pricingConditionsInfo.profile && this.pricingConditionsInfo.profile.customfields) {
          var profilePricing = _.find(this.pricingConditionsInfo.profile.customfields, function (elem) {
            return elem.id === 'custentity_kd_pricing_group_summary';
          });
          // eslint-disable-next-line
          this.profilePricingString = profilePricing && profilePricing.value && profilePricing.value.replace(/[\x00-\x1F\x7F-\x9F]/g, ' ');
          this.profilePricing = this.profilePricingString && this.profilePricingString.split(' ');
        }
        if (this.merchZoneConfig && this.pricingConditionsInfo) {
          this.showPrice = this.validatePricingCondition(this.merchZoneConfig, this.pricingConditionsInfo);
        }
      };

      this.initialize(opts);
    }

    CustomMerchZonePricingView.prototype = Object.create(SCView.prototype);

    CustomMerchZonePricingView.prototype.constructor = CustomMerchZonePricingView;

    CustomMerchZonePricingView.prototype.validatePricingCondition = function (merchZoneConfig, pricingConditionsInfo) {
      var self = this;
      if (merchZoneConfig && merchZoneConfig.site === 'NABCO') {
        var restrictedUserRoleId = self.customRolesConfig && self.customRolesConfig.restrictedAccessRole;
        if(Number(restrictedUserRoleId) === Number(self.customerRole)) {
          return false;
        }
        if (this.priceNoFormatted > 0) {
          var showPrice = true;
          _.each(this.profilePricing, function (pricingProfile) {
            var pricingGroup = _.find(self.pricingConditionsInfo.pricingGroups, function (elem) {
              return elem.groupPricingId === pricingProfile;
            });
            if(pricingGroup && pricingGroup.manufacturerId === pricingConditionsInfo.itemManufacturer) {
              showPrice = !showPrice;
            }
            return true;
          });
          return showPrice;
        }
        return false;

      }
      if (self.itemInStock) {
        return _.includes(pricingConditionsInfo.suppliers, pricingConditionsInfo.itemSupplier);
      }
      return false;


    };

    CustomMerchZonePricingView.prototype.getUrlWithOrigin = function getUrlWithOrigin() {
      var resultingUrl = SC.SESSION.touchpoints.login;
      if (this.model && this.model.get('urlComponent')) {
        resultingUrl += '?origin=home&origin_hash=' + this.model.get('urlComponent');
      }
      return resultingUrl;
    },

    CustomMerchZonePricingView.prototype.getContext = function () {
      return {
        isLoggedIn: this.isLoggedIn,
        showPrice: this.showPrice,
        price: this.price || '',
        restrictedMessage: this.customRolesConfig && this.customRolesConfig.restrictedPriceMessage,
        loginUrlWithOrigin: this.getUrlWithOrigin()
      };
    };
    return CustomMerchZonePricingView;
  });
